import * as React from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';

import { P3, P6 } from 'src/components/Typography/Paragraph';
import { FormParserContext } from 'src/contexts/form.context';
import { AddToLabel } from 'src/models/form.model';
import { getCurrentSubprojectName } from 'src/store/subProject/subProject.getters';
import { makeStringFromTemplate } from 'src/tools/string.tools';

import classes from './Label.module.scss';

export function Label() {
  const { script, config } = React.useContext(FormParserContext);

  const projectName = useSelector(getCurrentSubprojectName);

  function makeLabel() {
    if (!script.label) return '';

    switch (script.addToLabel) {
      case AddToLabel.SUB_NAME:
        if (!projectName) return script.label;

        return makeStringFromTemplate(script.label, [projectName]);
      default:
        return script.label;
    }
  }

  const isShowIsRequired = !config?.noRequired && script.isRequired;

  if (!script.label && !isShowIsRequired) {
    return null;
  }

  const text = makeLabel();

  return (
    <label className={classes.container}>
      <P3 className={clsx(classes.label, 't-ellipsis')} title={text}>
        {text}
      </P3>
      {!config?.noRequired && script.isRequired && <P6 className={classes.required}>* Required</P6>}
    </label>
  );
}
